import { FC } from "react";
import { CtaPrimary, CtaSecondary } from "../..";
import classNames from "classnames";
import { ModalInstantSell } from "../../modals";
import NftImage from "../../images/NftImage";
import { Loan } from "../../../logic/types/loan/Loan";
import useModalHelper from "../../modals/hooks/useModalHelper";
import { Address } from "viem";
import { BasicProps } from "components/types/BasicProps";
import TokenIcon from "components/icons/TokenIcon";
import { INft } from "logic/types/nft/INft";
import { useListForSale } from "logic/hooks/borrow";
import track from "logic/track";

type Props = BasicProps & {
  loan: Loan;
  nft: INft;
  onNftUnlisted?: (loanId: Address, nft: INft) => void;
  onSold?: (loanId: Address, nft: INft, amountRepaid?: bigint) => void;
};

export const NftLoanDetail: FC<Props> = (props) => {
  const { nft, loan, className, onNftUnlisted, onSold } = props;
  const [isModalInstantSellOpen, toggleInstantSell, launcherInstantSell] =
    useModalHelper();

  const { ctaLiteral, handleListClick } = useListForSale(
    loan,
    nft,
    onNftUnlisted
  );

  const handleList = () => {
    track.click('loan_click_list')

    handleListClick()
  }

  const handleInstantSell = () => {
    track.click('loan_click_sell')

    launcherInstantSell()
  };

  return (
    <>
      <tr
        className={classNames(
          "bg-[#2B2653] border-[#FFF6F6] hover:bg-primary/10 text-base font-medium",
          className
        )}
      >
        <td
          scope="row"
          className="flex items-center gap-3 py-4 px-3 font-medium ml-[30px]"
        >
          <NftImage
            className="w-16 h-16 rounded-md"
            src={nft.image}
            alt={nft.alt}
          />
        </td>
        <td className="px-3 font-bold">{nft.nameToShow}</td>
        <td className="px-3 items-center">
          <div className="flex gap-x-2 items-center">
            {nft.currency.formatAmount(nft.valuation)}
            <TokenIcon className="h-4 w-4" currency={nft.currency} />
          </div>
        </td>
        <td className="px-3"></td>
        <td className="py-4 px-3"></td>
        <td className="py-4 px-3"></td>
        <td className="py-4 px-3"></td>
        <td className="px-3">
          {(loan.isListForSaleAvailable(nft) || nft.isCancelListAvailable) && (
            <div className="flex">
              <CtaSecondary className="w-40" onClick={handleList}>
                {ctaLiteral}
              </CtaSecondary>
            </div>
          )}
        </td>
        <td className="px-3">
          {loan.isInstantSellAvailable && (
            <CtaPrimary className="w-40" onClick={handleInstantSell}>
              Instant sell
            </CtaPrimary>
          )}
        </td>
      </tr>
      {isModalInstantSellOpen && (
        <ModalInstantSell
          isOpen={isModalInstantSellOpen}
          toggleModal={toggleInstantSell}
          loan={loan}
          nft={nft}
          onSold={onSold}
        />
      )}
    </>
  );
};
